/**
 * @fileoverview gRPC-Web generated client stub for dash.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v0.0.0
// source: dash/v1/file.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var types_v1_entity_pb = require('../../types/v1/entity_pb.js')
const proto = {};
proto.dash = {};
proto.dash.v1 = require('./file_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dash.v1.FileServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dash.v1.FileServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.FileUploadRequest,
 *   !proto.dash.v1.FileUploadResponse>}
 */
const methodDescriptor_FileService_FileUpload = new grpc.web.MethodDescriptor(
  '/dash.v1.FileService/FileUpload',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.FileUploadRequest,
  proto.dash.v1.FileUploadResponse,
  /**
   * @param {!proto.dash.v1.FileUploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.FileUploadResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.FileUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.FileUploadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.FileUploadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.FileServiceClient.prototype.fileUpload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.FileService/FileUpload',
      request,
      metadata || {},
      methodDescriptor_FileService_FileUpload,
      callback);
};


/**
 * @param {!proto.dash.v1.FileUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.FileUploadResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.FileServicePromiseClient.prototype.fileUpload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.FileService/FileUpload',
      request,
      metadata || {},
      methodDescriptor_FileService_FileUpload);
};


module.exports = proto.dash.v1;

